import apiClient from '@/services/axios'

export async function get(query) {
  /*const encode = (str) => {
    var i = str.length,
        aRet = [];

    while (i--) {
        var iC = str[i].charCodeAt();
        if (iC < 65 || iC > 127 || (iC>90 && iC<97)) {
            aRet[i] = '&#'+iC+';';
        } else {
            aRet[i] = str[i];
        }
    }
    return aRet.join('');
}
  query = encode(query)
  console.log("Q", query);*/
  var response = await apiClient.get(process.env.VUE_APP_CRM_API_BASE_URL + '/GuestProfiles?query=' + query)
  if (response) {
    return response.data
  }

  throw new Error('Unable to query guest profiles')
}
